import React from 'react';
import { Sparkles } from 'lucide-react';
import AgentLanding from '../../agents/shared/AgentLanding';
import { profilingAgentSpec } from './spec';

const ProfilingAgentPage: React.FC = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-cargo-text flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-cargo-accent" />
          Profiling Agent
        </h1>
        <p className="text-cargo-muted mt-1">
          Onboard data products in chat — profile, dictionary, rules, mapping, project creation
        </p>
      </div>
      <AgentLanding spec={profilingAgentSpec} />
    </div>
  );
};

export default ProfilingAgentPage;
